import * as Sentry from '@sentry/browser';
import React, {ErrorInfo} from 'react';
import {Button} from '~/components/Button';
import {IntentText} from '~/components/Form';
import {InfoWrapper, MiddleLayout} from '~/components/Layout';
import style from './errorBoundary.module.scss';

export class ErrorBoundary extends React.Component<{}, { error: Error; errorInfo: ErrorInfo }> {
    constructor(props) {
        super(props);
        this.state = {error: null, errorInfo: null};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        Sentry.captureException(error);
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <MiddleLayout variant="form">
                    <InfoWrapper className={style.errorBoundary}>
                        <div className={style.errorDescription}>Unexpected Error</div>
                        <IntentText className={style.errorMessage}>
                            Sorry, something went wrong on our end. We are currently trying to fix the problem.
                        </IntentText>
                        <div className={style.actions}>
                            <Button leftIcon={<i className='fa fa-home'/>} onClick={() => location.href = '/'}>Home</Button>
                            <Button leftIcon={<i className='fa fa-refresh'/>} onClick={() => location.reload()}>Refresh</Button>
                        </div>
                    </InfoWrapper>
                </MiddleLayout>
            );
        }
        return this.props.children;
    }
}
